<template>
  <svg
    class="download-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M15.025 14.5V10.95H16.475V14.5C16.475 14.8929 16.3279 15.2367 16.0323 15.5323C15.7367 15.8279 15.3929 15.975 15 15.975H2C1.60706 15.975 1.2633 15.8279 0.967678 15.5323C0.67205 15.2367 0.525 14.8929 0.525 14.5V10.95H1.975V14.5V14.525H2H15H15.025V14.5ZM7.775 9.275V0.025H9.225V9.275V9.33536L9.26768 9.29268L12.25 6.31036L13.2896 7.35L8.5 12.1396L3.71036 7.35L4.75 6.31036L7.73232 9.29268L7.775 9.33536V9.275Z"
      stroke-width="0.05"
    />
  </svg>
</template>

<script>
export default {
  name: "DownloadIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.download-icon {
  path {
    fill: $aisea-blue; // override
    stroke: $aisea-blue; // override
  }
}
</style>
